import DentistrySection from './DentistrySection';
import TestimonialsSection from '../Common/TestimonialSection';
import DentalServices from './DentalServices';
import PricingInsuranceSection from '../Common/PricingInsuranceSection';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import PromoSection from '../Common/PromoSection';

import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import AnimatedSection from '../Common/AnimatedSection';
import { Link } from 'react-router';
import WhatsAppChatbot from '../Common/WhatsAppChatbot';

const Home = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section with Video Background */}
      <section className="relative h-screen w-full overflow-hidden">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover scale-105 animate-fade-in duration-1000"
        >
          <source src="/PristineWebsiteReel.mp4" type="video/mp4" />
          <span className="text-gray-600">Your browser does not support the video tag.</span>
        </video>

        {/* Custom Overlay with Brand Gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60">
          {/* Accent Elements */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              {/* Top left accent */}
              <path
                d="M-50,0 C100,100 200,50 300,150"
                stroke="#0AB"
                strokeWidth="6"
                strokeOpacity="0.3"
                fill="none"
              />

              {/* Bottom right accent */}
              <path
                d="M100%,100% C80%,90% 70%,95% 60%,85%"
                stroke="#8D2"
                strokeWidth="6"
                strokeOpacity="0.3"
                fill="none"
              />

              {/* Abstract dental shape */}
              <path
                d="M50%,85% C55%,80% 60%,85% 50%,90% C40%,85% 45%,80% 50%,85%"
                fill="#8D2"
                fillOpacity="0.2"
              />
            </svg>
          </div>

          {/* Hero Content */}
          <div className="flex flex-col items-center justify-center h-full text-center px-4 sm:px-6 animate-slide-up relative z-10">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 animate-fade-in-up">
                Welcome to <span className="text-[#0AB] drop-shadow-md">Pristine</span> <span className="text-[#8D2] drop-shadow-md">Smile</span>
              </h1>
              <p className="text-lg sm:text-xl text-white mb-10 animate-fade-in-up [animation-delay:200ms] max-w-2xl mx-auto">
                Providing exceptional dental care with a gentle touch for your entire family
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up [animation-delay:400ms]">
                <Link to='/schedule-appointment'
                  className="cursor-pointer bg-gradient-to-r from-[#0AB] to-[#0da3b8] hover:from-[#0895a7] hover:to-[#0c92a6] text-white px-8 py-3 rounded-lg text-lg font-medium
                         transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  Schedule an Appointment
                </Link>
                <Link to='/service'
                  className="cursor-pointer bg-gradient-to-r from-[#8D2] to-[#9de438] hover:from-[#7bc021] hover:to-[#8bd02d] text-white px-8 py-3 rounded-lg text-lg font-medium
                         transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  Explore Our Services
                </Link>
              </div>
            </div>
          </div>

          {/* Scroll Indicator */}
          <div
            className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer z-20"
            onClick={() => scrollToSection('dentistry-section')}
          >
            <div className="p-2 rounded-full bg-white/10 backdrop-blur-sm">
              <ChevronDown className="text-white w-8 h-8" />
            </div>
          </div>

          {/* Bottom Wave Accent */}
          <div className="absolute bottom-0 left-0 w-full">
            <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-16 md:h-24">
              <path
                d="M0,0 C150,90 350,0 500,80 C650,160 750,40 900,100 C1050,160 1150,50 1200,80 L1200,120 L0,120 Z"
                className="fill-[#0AB] opacity-30"></path>
              <path
                d="M0,0 C150,60 350,0 500,40 C650,80 750,20 900,60 C1050,100 1150,30 1200,50 L1200,120 L0,120 Z"
                className="fill-[#8D2] opacity-20"></path>
            </svg>
          </div>
        </div>
      </section>

      {/* Main Content Sections */}
      <main className="w-full" style={{ marginTop: '-35px' }}>
        <AnimatedSection id="dentistry-section">
          <DentistrySection />
        </AnimatedSection>

        <AnimatedSection id="services-section">
          <DentalServices />
        </AnimatedSection>

        <AnimatedSection id="promo-section">
          <PromoSection />
        </AnimatedSection>

        <AnimatedSection id="pricing-section">
          <PricingInsuranceSection />
        </AnimatedSection>

        <AnimatedSection id="testimonials-section">
          <TestimonialsSection />
        </AnimatedSection>

        <AnimatedSection id="visit-section">
          <VisitUsSection />
        </AnimatedSection>

        <AnimatedSection id="book-section">
          <BookVisitSection />
        </AnimatedSection>
      </main>

      {/* <WhatsAppChatbot /> */}
    </div>
  );
};

export default Home;